import React from "react";
import { X } from "phosphor-react";
import { InputWithSuffixHelpersFloatingLabel } from "./Shared";

export function NumberInput({ label, value, setValue, suffix, validate }) {
  return (
    <InputWithSuffixHelpersFloatingLabel
      type="number"
      label={label}
      id={label}
      value={value}
      onChange={(e) =>
        !isNaN(e.target.value) && setValue(parseFloat(e.target.value))
      }
      suffix={suffix}
      helpers={[<X weight="thin" size={14} onClick={() => setValue(0)} />]}
      validate={validate}
    />
  );
}
